import React from "react";

//Panels
import { LearnMore } from "../../../../CTA/CTA";

//Images
import how1 from "../../images/financing/website.svg";
import how2 from "../../images/financing/check.svg";
import how3 from "../../images/financing/credit-card.svg";
import how4 from "../../images/financing/hand.svg";

//SEO
import SEO from "../../../../SEO/index.js";

const Financing = () => {
  return (
    <>
      <SEO
        title="Financing for Paving Services | Pacific Pavingstone"
        description="We want to help our clients remain in budget and feel comfortable with their investment. This is why we offer a credit plan that allows you to pay over time."
        profileURL={"https://www.pacificpavingstone.com/about-us/financing"}
        type="website"
      />
      <div className="row justify-content-center page-financing">
        <div className="col-11 col-xl-10">
          <div className="row justify-content-center">
            <div className="col-9 col-md-6 col-lg-3 text-center">
              <h3 className="text-uppercase text-blue">Financing</h3>
            </div>
          </div>
          <div className="row justify-content-center panel-description text-center mt-4">
            <div className="col-lg-8">
              <p>We care about helping our clients not only remain in their budget,
              but also feel comfortable with the investment they are making. This
              is why we offer a credit plan that will allow you to pay for your
              project over time.</p>
            </div>
          </div>
          <div className="row justify-content-center panel-how">
            <div className="col-12">
              <h3 className="text-center text-uppercase text-blue">
                How it Works:
              </h3>
            </div>
            <div className="col-lg-11 mt-5">
              <div className="row justify-content-center text-center">
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={how1} alt="Apply Online" />
                  </div>
                  <p>Apply Online with Wells Fargo Bank</p>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={how2} alt="Get Response right away" />
                  </div>
                  <p>
                    Get a response right away determining if you are qualified.
                  </p>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={how3} alt="Get your new Credit Card" />
                  </div>
                  <p>If qualified, get your new credit card in the mail.</p>
                </div>
                <div className="col-8 col-md-5 col-lg-3 mt-3">
                  <div className="image">
                    <img src={how4} alt="Use card for installments" />
                  </div>
                  <p>
                    Use this credit card to make monthly installments toward your
                    project.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center panel-credit">
            <div className="col-lg-8">
              <h4 className="text-uppercase text-center text-blue">
                This credit card also brings you:
              </h4>
              <ul className="mt-4">
                <li>
                  <p>
                    Revolving line of credit that you can use over and over again.
                  </p>
                </li>
                <li>
                  <p>Special fincancing where available.</p>
                </li>
                <li>
                  <p>Convenient monthly payments to fit your budget.</p>
                </li>
                <li>
                  <p>
                    Easy to use online accoutn manangement and bill payment
                    options.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <LearnMore />
        </div>
      </div>
    </>
  );
};

export default Financing;
